import { CoinDropdownItem } from "@components/dropdown/CoinDropdownItem"
import { CustomDropdown } from "@components/dropdown/CustomDropdown"
import { useCoins } from "@contexts/CoinsContext"
import useAlert from "@hooks/AlertHook"
import useModal from "@hooks/ModalHook"
import { CoinResponse } from "baaanggg"
import { useState } from "react"
import { Modal } from "react-bootstrap"

type Price = { [key: string]: number }

type Props = {
    onChange: (prices: Price) => void,
    prices: Price
}

export function PricesModal({ onChange, prices }: Props) {
    const alert = useAlert()
    const { showModal, modalId, closeModal } = useModal()
    const { coins, getCoin } = useCoins()

    const [selectedCoin, setSelectedCoin] = useState<CoinResponse>()
    const [amount, setAmount] = useState("")

    const onAdd = () => {
        const parsedAmount = Number.parseFloat(amount)

        if (isNaN(parsedAmount)) {
            alert.failed(`Amount must be a number greater than 0, use '.' as decimal separator`)
            return
        }

        if (parsedAmount <= 0) {
            alert.failed("Amount must be greater than 0%")
            return
        }

        if (selectedCoin === undefined) {
            alert.failed("Please select payment coin")
            return
        }

        prices[selectedCoin.id] = parsedAmount * Math.pow(10, selectedCoin.decimals)

        onChange(prices)
        setAmount("")
        setSelectedCoin(undefined)
    }

    const onEdit = (coinId: string) => {
        const coin = getCoin(coinId)
        setAmount((prices[coinId] / Math.pow(10, coin!.decimals)).toString())
        setSelectedCoin(coins.find(e => e.id === coinId))
    }

    const onDelete = (coinId: string) => {
        delete prices[coinId]
        onChange({ ...prices })
    }

    return <Modal show={showModal && modalId === "prices"} dialogClassName="max-w-3xl">
        <Modal.Header >
            <Modal.Title>Edit Prices</Modal.Title>
            <button type="button" className="btn-close" onClick={() => closeModal()} aria-label="Close">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    className="h-6 w-6 fill-jacarta-700 dark:fill-white"
                >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                        d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
                    />
                </svg>
            </button>
        </Modal.Header>
        <Modal.Body className="p-6">

            {
                Object.entries(prices).map(([coinId, amount]) => {
                    const coin = coins.find(value => value.id === coinId);

                    return <div
                        key={coinId}
                        className="flex flex-shrink-0 items-center mt-1 text-xs font-medium text-jacarta-500 dark:text-jacarta-300 sm:text-sm">
                        <div
                            className="flex items-center w-full text-xs font-medium text-jacarta-500 dark:text-jacarta-300 sm:text-sm">
                            <div
                                className="flex h-10 items-center border-r-0 border border-jacarta-100 bg-white p-3 first:rounded-l-lg last:rounded-r-lg dark:border-gray-400 dark:bg-gray-900 sm:px-4 sm:py-2 text-white">
                                {coin?.name ?? "-"}
                            </div>
                            <div
                                className="flex h-10 w-full items-center whitespace-nowrap border border-jacarta-100 bg-white p-3 first:rounded-l-lg last:rounded-r-lg dark:border-gray-400 dark:bg-gray-900 sm:px-4 sm:py-2 text-white">
                                {(amount / Math.pow(10, coin?.decimals ?? 6)).toLocaleString()}
                            </div>
                        </div>
                        <div
                            className="ml-2 flex items-center text-xs font-medium text-jacarta-500 dark:text-jacarta-300 sm:text-sm">
                            <button
                                onClick={() => onEdit(coinId)}
                                className="flex h-10 w-10 group cursor-pointer items-center justify-center border-r-0 first:rounded-l-lg last:rounded-r-lg dark:bg-gray-900 dark:border-gray-400 border border-jacarta-100 bg-white dark:hover:bg-jacarta-500 dark:hover:border-transparent hover:bg-accent hover:border-accent">
                                <svg className="h-4 w-4 fill-jacarta-700 dark:fill-gray-400 group-hover:fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"><path d="M1.172,19.119A4,4,0,0,0,0,21.947V24H2.053a4,4,0,0,0,2.828-1.172L18.224,9.485,14.515,5.776Z" /><path d="M23.145.855a2.622,2.622,0,0,0-3.71,0L15.929,4.362l3.709,3.709,3.507-3.506A2.622,2.622,0,0,0,23.145.855Z" /></svg>
                            </button>
                            <button
                                onClick={() => onDelete(coinId)}
                                className="flex h-10 w-10 group cursor-pointer items-center justify-center first:rounded-l-lg last:rounded-r-lg dark:bg-gray-900 dark:border-gray-400 border border-jacarta-100 bg-white dark:hover:bg-jacarta-500 dark:hover:border-transparent hover:bg-accent hover:border-accent">
                                <svg className="h-4 w-4 fill-jacarta-700 dark:fill-gray-400 group-hover:fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"><path d="M23,3H18V2.5A2.5,2.5,0,0,0,15.5,0h-7A2.5,2.5,0,0,0,6,2.5V3H1V6H3V21a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V6h2ZM18,21H6V6H18Z" /><rect x="8" y="9" width="3" height="9" /><rect x="13" y="9" width="3" height="9" /></svg>
                            </button>
                        </div>
                    </div>
                }
                )
            }

            <div
                className={`flex flex-shrink-0 items-center ${Object.keys(prices).length > 0 && "mt-5"} text-xs font-medium text-jacarta-500 dark:text-jacarta-300 sm:text-sm`}>
                <div
                    className="flex w-1/2 items-center text-xs font-medium sm:text-sm mr-2">
                    <CustomDropdown
                        value={selectedCoin?.id}
                        format={coin => coin.name}
                        onSelected={coin => setSelectedCoin(coin)}
                        builder={(coin, isSelected) => <CoinDropdownItem coin={coin} isSelected={isSelected} />}
                        items={coins} />
                </div>
                <div
                    className="flex w-full items-center text-xs font-medium sm:text-sm mr-2">
                    <input
                        value={amount}
                        onChange={({ target }) => setAmount(target.value)}
                        placeholder="100"
                        className="flex h-10 w-full items-center focus:ring-jacarta-500 hover:ring-2 text-white whitespace-nowrap border border-jacarta-100 bg-white p-3 first:rounded-l-lg last:rounded-r-lg dark:border-gray-400 dark:bg-gray-900 sm:px-4 sm:py-2 placeholder:text-gray-400" />
                </div>
                <div
                    className="flex items-center text-xs font-medium text-jacarta-500 dark:text-jacarta-300 sm:text-sm">
                    <button
                        onClick={onAdd}
                        className="flex h-10 w-10 group cursor-pointer items-center justify-center first:rounded-l-lg last:rounded-r-lg dark:bg-gray-900 dark:border-gray-400 border border-jacarta-100 bg-white dark:hover:bg-jacarta-500 dark:hover:border-transparent hover:bg-accent hover:border-accent">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="fill-gray-400 group-hover:fill-white"
                        >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" />
                        </svg>
                    </button>
                </div>
            </div>
        </Modal.Body>
    </Modal >
}